if (!customElements.get('calc-shipping-rate-block')) {
  const STORAGE_KEY = 'f-cart-selected-shipping-rate';
  const ZIP_LENGTH = 8;
  const DEBOUNCE_TIME = 550;

  const BRAZIL_PROVINCES_BY_ZIP = [
    { min: 1000, max: 19999, province: 'São Paulo' },
    { min: 20000, max: 28999, province: 'Rio de Janeiro' },
    { min: 29000, max: 29999, province: 'Espírito Santo' },
    { min: 30000, max: 39999, province: 'Minas Gerais' },
    { min: 40000, max: 48999, province: 'Bahia' },
    { min: 49000, max: 49999, province: 'Sergipe' },
    { min: 50000, max: 56999, province: 'Pernambuco' },
    { min: 57000, max: 57999, province: 'Alagoas' },
    { min: 58000, max: 58999, province: 'Paraíba' },
    { min: 59000, max: 59999, province: 'Rio Grande do Norte' },
    { min: 60000, max: 63999, province: 'Ceará' },
    { min: 64000, max: 64999, province: 'Piauí' },
    { min: 65000, max: 65999, province: 'Maranhão' },
    { min: 66000, max: 68899, province: 'Pará' },
    { min: 68900, max: 68999, province: 'Amapá' },
    { min: 69000, max: 69299, province: 'Amazonas' },
    { min: 69300, max: 69399, province: 'Roraima' },
    { min: 69400, max: 69899, province: 'Amazonas' },
    { min: 69900, max: 69999, province: 'Acre' },
    { min: 70000, max: 72799, province: 'Distrito Federal' },
    { min: 72800, max: 72999, province: 'Goiás' },
    { min: 73000, max: 73699, province: 'Distrito Federal' },
    { min: 73700, max: 76799, province: 'Goiás' },
    { min: 77000, max: 77999, province: 'Tocantins' },
    { min: 78000, max: 78899, province: 'Mato Grosso' },
    { min: 78900, max: 78999, province: 'Rondônia' },
    { min: 79000, max: 79999, province: 'Mato Grosso do Sul' },
    { min: 80000, max: 87999, province: 'Paraná' },
    { min: 88000, max: 89999, province: 'Santa Catarina' },
    { min: 90000, max: 99999, province: 'Rio Grande do Sul' },
  ];

  const UF_TO_STATE_NAME = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
  };

  const LOCAL_DELIVERY_ZONES = [
    {
      name: 'Frete Grátis Fortaleza',
      prefixes: [
        '600', '601', '602', '603', '604', '605', '606', '607', '608',
        '609', '610', '611', '612', '613', '614', '615', '616', '617',
        '618', '619',
      ],
    },
  ];

  const moneyFormat = () => window.FoxThemeSettings?.money_format || '${{amount}}';

  function toDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, ZIP_LENGTH);
  }

  function formatZip(value) {
    const digits = toDigits(value);

    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return digits;
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeCountry(country) {
    const value = String(country || '').trim();

    if (!value) return 'Brazil';

    const normalized = normalizeText(value);

    if (normalized === 'brasil' || normalized === 'br') return 'Brazil';

    return value;
  }

  function detectBrazilProvinceFromZip(zip) {
    const digits = toDigits(zip);

    if (digits.length < ZIP_LENGTH) return '';

    const prefix = Number.parseInt(digits.slice(0, 5), 10);

    if (!Number.isFinite(prefix)) return '';

    const match = BRAZIL_PROVINCES_BY_ZIP.find((range) => {
      return prefix >= range.min && prefix <= range.max;
    });

    return match ? match.province : '';
  }

  function priceToCents(rate) {
    if (!rate) return 0;

    if (typeof rate.price_cents === 'number') {
      return rate.price_cents;
    }

    const rawPrice = String(rate.price || '0')
      .replace(/[^\d,.-]/g, '')
      .replace(',', '.');

    const parsedPrice = Number.parseFloat(rawPrice);

    return Number.isFinite(parsedPrice) ? Math.round(parsedPrice * 100) : 0;
  }

  function formatPrice(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, moneyFormat());
    }

    return (Number(cents || 0) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function parseMoneyToCents(value) {
    const text = String(value || '').trim();

    if (!text) return 0;

    let normalized = text.replace(/[^\d,.-]/g, '');

    if (normalized.includes(',')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    }

    const parsed = Number.parseFloat(normalized);

    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function getDeliveryText(rate) {
    if (!rate) return '';

    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const days = rate.delivery_days
        .map((day) => Number.parseInt(day, 10))
        .filter((day) => Number.isFinite(day));

      if (days.length > 0) {
        const maxDays = Math.max(...days);
        return `${maxDays} DIAS ÚTEIS`;
      }
    }

    const deliveryText = rate.delivery_date || rate.delivery_range || rate.description || '';

    return String(deliveryText).trim().toUpperCase();
  }

  function getLocalDeliveryZoneName(zip) {
    const digits = toDigits(zip);

    if (!digits) return null;

    const zone = LOCAL_DELIVERY_ZONES.find((zoneItem) => {
      return zoneItem.prefixes.some((prefix) => digits.startsWith(prefix));
    });

    return zone ? zone.name : null;
  }

  function isLocalDeliveryRate(rate) {
    const name = normalizeText(rate?.name || '');

    return (
      name === 'local delivery' ||
      name.includes('local delivery') ||
      name === 'entrega local' ||
      name.includes('entrega local')
    );
  }

  function getShippingRateDisplayName(rate, zip) {
    const originalName = String(rate?.name || '').trim();

    if (isLocalDeliveryRate(rate)) {
      const zoneName = getLocalDeliveryZoneName(zip);

      if (zoneName) {
        return zoneName;
      }
    }

    return originalName;
  }

  function buildRateLabel(rate, zip) {
    const rateName = getShippingRateDisplayName(rate, zip);
    const price = formatPrice(priceToCents(rate));
    const deliveryText = getDeliveryText(rate);

    return `${rateName} - ${price}${deliveryText ? ` (${deliveryText})` : ''}`;
  }

  function getStoredShipping() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function setStoredShipping(payload) {
    try {
      if (!payload) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      // sessionStorage pode estar bloqueado em alguns navegadores.
    }
  }

  function getErrorMessageFromResult(result) {
    if (!result || typeof result !== 'object') return '';

    const firstError = Object.values(result).find((value) => {
      return Array.isArray(value) && value.length;
    });

    return firstError ? firstError[0] : '';
  }

  async function fetchAddressByZip(zip) {
    const digits = toDigits(zip);

    if (digits.length !== ZIP_LENGTH) return null;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);

      if (!response.ok) return null;

      const data = await response.json();

      if (!data || data.erro) return null;

      const provinceCode = String(data.uf || '').trim().toUpperCase();
      const province = UF_TO_STATE_NAME[provinceCode] || provinceCode;

      return {
        zip: formatZip(digits),
        zipDigits: digits,
        address1: String(data.logradouro || '').trim(),
        neighborhood: String(data.bairro || '').trim(),
        city: String(data.localidade || '').trim(),
        provinceCode,
        province,
        country: 'Brazil',
      };
    } catch (error) {
      console.warn('[ECOMHARD] Não foi possível buscar endereço pelo CEP:', error);
      return null;
    }
  }

  function buildCheckoutUrl(address) {
    const url = new URL('/checkout', window.location.origin);

    if (!address) {
      return url.toString();
    }

    url.searchParams.set('checkout[shipping_address][zip]', address.zip || address.zipDigits || '');
    url.searchParams.set('checkout[shipping_address][country]', address.country || 'Brazil');
    url.searchParams.set('checkout[shipping_address][province]', address.province || '');
    url.searchParams.set('checkout[shipping_address][city]', address.city || '');
    url.searchParams.set('checkout[shipping_address][address1]', address.address1 || '');

    return url.toString();
  }

  function wait(ms = 0) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  async function fetchShippingRates({ zip, country, province, signal }) {
    const url = new URL('/cart/shipping_rates.json', window.location.origin);

    url.searchParams.set('shipping_address[zip]', formatZip(zip));
    url.searchParams.set('shipping_address[country]', country);
    url.searchParams.set('shipping_address[province]', province);

    const response = await fetch(url.toString(), { signal });
    const result = await response.json();

    return result;
  }

  customElements.define(
    'calc-shipping-rate-block',
    class FooterCalcShippingRates extends HTMLElement {
      constructor() {
        super();

        this.rates = [];
        this.selectedRate = null;
        this.selectedRateIndex = 0;
        this.debounceTimer = null;
        this.abortController = null;
        this.initialized = false;
        this.initAddress = false;
        this.checkoutAddress = null;
        this.isRedirectingToCheckout = false;

        this.handleInput = this.handleInput.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleCheckoutClick = this.handleCheckoutClick.bind(this);
        this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.selectors = {
          zipCode: '[name="address[zip]"]',
          province: '[name="address[province]"]',
          country: '[name="address[country]"]',
          message: '[data-shipping-message]',
          price: '[data-shipping-price]',
          clearButton: '[data-shipping-clear]',
          countries: 'template',
        };

        this.domNodes = {
          zipCode: this.querySelector(this.selectors.zipCode),
          province: this.querySelector(this.selectors.province),
          country: this.querySelector(this.selectors.country),
          message: this.querySelector(this.selectors.message),
          price: this.querySelector(this.selectors.price),
          clearButton: this.querySelector(this.selectors.clearButton),
          countries: this.querySelector(this.selectors.countries),
        };

        if (!this.domNodes.zipCode || !this.domNodes.message || !this.domNodes.price) return;

        this.setupCountries();

        this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);

        this.domNodes.zipCode.addEventListener('input', this.handleInput);
        this.domNodes.zipCode.addEventListener('keydown', this.handleKeydown);
        this.domNodes.zipCode.addEventListener('blur', () => {
          this.domNodes.zipCode.value = formatZip(this.domNodes.zipCode.value);
        });

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.addEventListener('click', this.handleClear);
        }

        document.addEventListener('cart:updated', this.handleCartUpdate);
        document.addEventListener('click', this.handleCheckoutClick, true);
        document.addEventListener('submit', this.handleCheckoutSubmit, true);

        const pubSubEvents = window.PUB_SUB_EVENTS || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null);

        if (window.FoxThemeEvents && pubSubEvents?.cartUpdate) {
          this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(
            pubSubEvents.cartUpdate,
            this.handleCartUpdate
          );
        }

        this.restorePreviousShipping();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.handleCartUpdate);
        document.removeEventListener('click', this.handleCheckoutClick, true);
        document.removeEventListener('submit', this.handleCheckoutSubmit, true);

        if (typeof this.cartUpdateUnsubscriber === 'function') {
          this.cartUpdateUnsubscriber();
        }

        if (this.domNodes?.clearButton) {
          this.domNodes.clearButton.removeEventListener('click', this.handleClear);
        }

        if (this.abortController) {
          this.abortController.abort();
        }
      }

      setupCountries() {
        if (this.initAddress) return true;

        const { country, province, countries } = this.domNodes || {};

        if (!country || !province || !countries) return false;

        country.innerHTML = countries.innerHTML;

        this.selectCountryOption(country.dataset.default || this.dataset.defaultCountry || 'Brazil');

        if (window.Shopify && window.Shopify.CountryProvinceSelector) {
          new window.Shopify.CountryProvinceSelector(
            country.id,
            province.id,
            {
              hideElement: province.closest('.form-field')?.id || 'AddressProvinceContainer',
            }
          );

          this.selectCountryOption(country.dataset.default || this.dataset.defaultCountry || 'Brazil');
          country.dispatchEvent(new Event('change', { bubbles: true }));

          this.initAddress = true;
          return true;
        }

        window.setTimeout(() => this.setupCountries(), 250);

        return false;
      }

      selectCountryOption(preferredCountry = 'Brazil') {
        const country = this.domNodes?.country;

        if (!country) return false;

        const preferred = normalizeText(preferredCountry);
        const options = Array.from(country.options || []);

        const match = options.find((option) => {
          const value = normalizeText(option.value);
          const text = normalizeText(option.textContent);

          return (
            value === preferred ||
            text === preferred ||
            value === 'brazil' ||
            text === 'brazil' ||
            value === 'brasil' ||
            text === 'brasil'
          );
        });

        if (match) {
          country.value = match.value;
          country.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }

        return false;
      }

      async waitForProvinceOptions() {
        const province = this.domNodes?.province;

        if (!province) return false;

        for (let index = 0; index < 20; index += 1) {
          if (province.options && province.options.length > 0) {
            return true;
          }

          await wait(50);
        }

        return province.options && province.options.length > 0;
      }

      async selectProvinceByNameOrCode(provinceName, provinceCode = '') {
        this.setupCountries();
        this.selectCountryOption('Brazil');

        await this.waitForProvinceOptions();

        const provinceSelect = this.domNodes?.province;

        if (!provinceSelect) return false;

        const normalizedProvinceName = normalizeText(provinceName);
        const normalizedProvinceCode = normalizeText(provinceCode);
        const options = Array.from(provinceSelect.options || []);

        const match = options.find((option) => {
          const value = normalizeText(option.value);
          const text = normalizeText(option.textContent);

          return (
            value === normalizedProvinceName ||
            text === normalizedProvinceName ||
            value === normalizedProvinceCode ||
            text === normalizedProvinceCode
          );
        });

        if (match) {
          provinceSelect.value = match.value;
          provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }

        return false;
      }

      async selectProvinceForZip(zip, address = null) {
        if (address?.province || address?.provinceCode) {
          const selected = await this.selectProvinceByNameOrCode(address.province, address.provinceCode);

          if (selected) return true;
        }

        const fallbackProvince = detectBrazilProvinceFromZip(zip);

        if (fallbackProvince) {
          return this.selectProvinceByNameOrCode(fallbackProvince);
        }

        return false;
      }

      handleCartUpdate() {
        window.setTimeout(() => {
          this.updateTotal();
        }, 100);
      }

      handleInput(event) {
        const formattedZip = formatZip(event.target.value);
        event.target.value = formattedZip;

        const zipDigits = toDigits(formattedZip);

        this.checkoutAddress = null;

        if (zipDigits.length < ZIP_LENGTH) {
          this.clearRates();
          return;
        }

        window.clearTimeout(this.debounceTimer);

        this.debounceTimer = window.setTimeout(() => {
          this.fetchRates();
        }, DEBOUNCE_TIME);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter') return;

        event.preventDefault();

        const zipDigits = toDigits(this.domNodes.zipCode.value);

        if (zipDigits.length === ZIP_LENGTH) {
          this.fetchRates();
        }
      }

      handleRateChange(event) {
        this.selectRate(Number(event.target.value));
      }

      handleClear(event) {
        event.preventDefault();

        if (this.abortController) {
          this.abortController.abort();
        }

        window.clearTimeout(this.debounceTimer);

        this.domNodes.zipCode.value = '';
        this.domNodes.message.innerHTML = '';
        this.rates = [];
        this.checkoutAddress = null;

        this.clearSelectedShipping(true);
        this.setLoading(false);

        this.domNodes.zipCode.focus();
      }

      handleCheckoutClick(event) {
        if (!(event.target instanceof Element)) return;

        const checkoutButton = event.target.closest(
          'button[name="checkout"], input[name="checkout"], [data-checkout-button]'
        );

        if (!checkoutButton) return;

        event.preventDefault();
        event.stopPropagation();

        this.redirectToCheckout();
      }

      handleCheckoutSubmit(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) return;

        const hasCheckoutButton = form.querySelector(
          'button[name="checkout"], input[name="checkout"], [data-checkout-button]'
        );

        if (!hasCheckoutButton) return;

        event.preventDefault();
        event.stopPropagation();

        this.redirectToCheckout();
      }

      async redirectToCheckout() {
        if (this.isRedirectingToCheckout) return;

        this.isRedirectingToCheckout = true;

        const zip = toDigits(this.domNodes.zipCode?.value || '');

        try {
          if (zip.length === ZIP_LENGTH && !this.checkoutAddress) {
            this.checkoutAddress = await fetchAddressByZip(zip);
          }

          window.location.href = buildCheckoutUrl(this.checkoutAddress);
        } catch (error) {
          console.warn('[ECOMHARD] Erro ao redirecionar para checkout:', error);
          window.location.href = '/checkout';
        }
      }

      async restorePreviousShipping() {
        const storedShipping = getStoredShipping();

        if (!storedShipping?.zip) return;

        this.selectedRateIndex = Number(storedShipping.index || 0);
        this.domNodes.zipCode.value = formatZip(storedShipping.zip);

        await this.fetchRates({ keepSelectedIndex: true });
      }

      async fetchRates(options = {}) {
        const zip = toDigits(this.domNodes.zipCode.value);

        if (zip.length !== ZIP_LENGTH) return;

        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();
        const currentController = this.abortController;

        this.setLoading(true);
        this.domNodes.message.innerHTML = '';

        try {
          this.setupCountries();
          this.selectCountryOption('Brazil');

          const address = await fetchAddressByZip(zip);
          const currentZip = toDigits(this.domNodes.zipCode?.value || '');

          if (currentZip !== zip) return;

          if (address) {
            this.checkoutAddress = address;
          } else {
            this.checkoutAddress = null;
          }

          const provinceSelected = await this.selectProvinceForZip(zip, address);

          if (!provinceSelected) {
            this.renderMessage('Não foi possível identificar o estado desse CEP.');
            this.clearSelectedShipping(false);
            return;
          }

          const country = normalizeCountry(this.domNodes.country?.value || this.dataset.defaultCountry || 'Brazil');
          const province = String(this.domNodes.province?.value || '').trim();

          if (!province) {
            this.renderMessage('Não foi possível identificar o estado desse CEP.');
            this.clearSelectedShipping(false);
            return;
          }

          let result = await fetchShippingRates({
            zip,
            country,
            province,
            signal: this.abortController.signal,
          });

          if (
            (!Array.isArray(result?.shipping_rates) || result.shipping_rates.length === 0) &&
            address?.provinceCode &&
            normalizeText(address.provinceCode) !== normalizeText(province)
          ) {
            result = await fetchShippingRates({
              zip,
              country,
              province: address.provinceCode,
              signal: this.abortController.signal,
            });
          }

          if (Array.isArray(result?.shipping_rates) && result.shipping_rates.length > 0) {
            this.renderRates(result.shipping_rates, options);
            return;
          }

          if (Array.isArray(result?.shipping_rates) && result.shipping_rates.length === 0) {
            this.renderMessage(
              window.FoxThemeStrings?.noShippingRate ||
              'Não encontramos fretes para esse CEP. Você ainda pode finalizar a compra para confirmar no checkout.'
            );
            this.clearSelectedShipping(false);
            return;
          }

          const errorMessage = this.getErrorMessage(result);

          this.renderMessage(errorMessage || window.FoxThemeStrings?.cartError || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } catch (error) {
          if (error.name === 'AbortError') return;

          this.renderMessage(window.FoxThemeStrings?.cartError || 'Não foi possível calcular o frete.');
          this.clearSelectedShipping(false);
        } finally {
          if (this.abortController === currentController) {
            this.setLoading(false);
          }
        }
      }

      renderRates(rates, options = {}) {
        this.rates = Array.isArray(rates) ? rates : [];
        this.domNodes.message.innerHTML = '';

        if (!this.rates.length) {
          this.renderMessage(window.FoxThemeStrings?.noShippingRate || 'Não encontramos fretes para esse CEP.');
          this.clearSelectedShipping(false);
          return;
        }

        const zip = toDigits(this.domNodes.zipCode.value);
        const select = document.createElement('select');

        select.className = 'f-cart-shipping__select';
        select.setAttribute('aria-label', 'Escolha o frete');

        this.rates.forEach((rate, index) => {
          const option = document.createElement('option');

          option.value = String(index);
          option.textContent = buildRateLabel(rate, zip);
          option.dataset.priceCents = String(priceToCents(rate));

          select.appendChild(option);
        });

        select.addEventListener('change', this.handleRateChange);

        this.domNodes.message.appendChild(select);

        const requestedIndex = options.keepSelectedIndex ? this.selectedRateIndex : 0;
        const safeIndex = this.rates[requestedIndex] ? requestedIndex : 0;

        select.value = String(safeIndex);

        this.selectRate(safeIndex);
      }

      selectRate(index = 0) {
        const rate = this.rates[index];

        if (!rate) {
          this.clearSelectedShipping(false);
          return;
        }

        const zip = toDigits(this.domNodes.zipCode.value);
        const priceCents = priceToCents(rate);
        const displayName = getShippingRateDisplayName(rate, zip);

        this.selectedRate = rate;
        this.selectedRateIndex = index;

        this.domNodes.price.textContent = formatPrice(priceCents);

        this.classList.add('has-rates');

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.removeAttribute('hidden');
        }

        this.updateTotal(priceCents);

        setStoredShipping({
          zip,
          index,
          priceCents,
          name: displayName,
          originalName: rate.name,
          province: this.domNodes.province?.value || '',
        });
      }

      clearRates() {
        window.clearTimeout(this.debounceTimer);

        this.domNodes.message.innerHTML = '';
        this.rates = [];

        this.clearSelectedShipping(true);
      }

      clearSelectedShipping(clearStorage = true) {
        this.selectedRate = null;
        this.selectedRateIndex = 0;

        this.classList.remove('has-rates');

        this.domNodes.price.textContent = '--';

        if (this.domNodes.clearButton) {
          this.domNodes.clearButton.setAttribute('hidden', 'hidden');
        }

        this.updateTotal(null);

        if (clearStorage) {
          setStoredShipping(null);
        }
      }

      getSubtotalCents() {
        const subtotalWrapper = document.querySelector('.f-cart-drawer__block-subtotal[data-cart-subtotal-cents]');

        if (subtotalWrapper) {
          const subtotalCents = Number.parseInt(subtotalWrapper.dataset.cartSubtotalCents || '0', 10);

          if (Number.isFinite(subtotalCents) && subtotalCents > 0) {
            return subtotalCents;
          }
        }

        const priceElement = document.querySelector('[data-cart-price]');

        if (priceElement) {
          return parseMoneyToCents(priceElement.textContent);
        }

        return 0;
      }

      getOrCreateTotalRow() {
        let totalRow = document.querySelector('[data-cart-shipping-total-row]');

        if (totalRow) return totalRow;

        const subtotalRow = document.querySelector('.f-cart-drawer__block-subtotal .f-cart-drawer__totals');

        if (!subtotalRow) return null;

        totalRow = document.createElement('div');
        totalRow.className = 'f-cart-drawer__totals flex justify-between items-center';
        totalRow.setAttribute('data-cart-shipping-total-row', '');
        totalRow.classList.add('hidden');
        totalRow.innerHTML = `
          <h3 class="f-cart-drawer__subtotal h6">Total:</h3>
          <p class="f-cart-drawer__subtotal-value" data-cart-shipping-total></p>
        `;

        subtotalRow.insertAdjacentElement('afterend', totalRow);

        return totalRow;
      }

      updateTotal(priceCents = undefined) {
        const totalRow = this.getOrCreateTotalRow();

        if (!totalRow) return;

        const totalValue = totalRow.querySelector('[data-cart-shipping-total]');

        if (!totalValue) return;

        let currentPriceCents = priceCents;

        if (typeof currentPriceCents === 'undefined' && this.selectedRate) {
          currentPriceCents = priceToCents(this.selectedRate);
        }

        if (currentPriceCents === null || typeof currentPriceCents === 'undefined') {
          totalRow.classList.add('hidden');
          totalValue.textContent = '';
          return;
        }

        const subtotalCents = this.getSubtotalCents();

        totalValue.textContent = formatPrice(subtotalCents + currentPriceCents);
        totalRow.classList.remove('hidden');
      }

      renderMessage(message) {
        this.domNodes.message.innerHTML = `<p class="f-cart-shipping__message-text">${message}</p>`;
      }

      getErrorMessage(result) {
        return getErrorMessageFromResult(result);
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
        this.domNodes.zipCode.toggleAttribute('readonly', isLoading);
      }
    }
  );
}